<div *ngIf="!isAuthyCallback && (!!selectedPage && selectedPage==='KEYCLOAK')">
  <set-password></set-password>
</div>

<div *ngIf="isAuthyLoggedIn">
  <set-password></set-password>
</div>
